module.exports = __webpack_public_path__ + "img/KBC_logo.0d889f3e.png";